import { useState, useRef, useMemo, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { handleImageError } from '../../Utils/helpers';

import profileimage from '../../Static/icons/user.svg';

import { ReactComponent as ArrowIcon } from '../../Static/icons/arrow.svg';
import { ReactComponent as ArrowSmallIcon } from '../../Static/icons/arrow_small.svg';
import useWindowSize from '../../Utils/Hooks/useWindowSize';
import { constants } from '../../Configs/constants';
import {
  StyledObjectsCardset,
  StyledObjectsCard,
  StyledCardInfo,
  StyledCardInfoDetails,
  StyledCardInfoDetail,
  StyledCardTitle,
  StyledCardPrice,
  StyledCardMore,
  StyledTeamCardsetWrapper,
  StyledTeamCardset,
  StyledTeamSlider,
  StyledTeamCard,
  StyledIndicators,
  StyledTeamControls,
  StyledBrokersCardset,
  StyledMoreButtonWrapper,
  StyledStateLabelWrapper,
  StyledSelectButton,
  StyledBrokerInfo,
} from './StyledCardset';

import { MoreButton } from '../UI/Buttons';
import { Radio, RoundRadio } from '../UI/Radio';

const {
  CATEGORIES,
  urls: { CONSOLE_OBJECTS, HOST_FRONT, OBJECTS },
  BASE_URL,
} = constants;

export const ObjectCard = ({
  _id,
  category,
  title,
  images,
  rooms,
  square,
  address,
  price,
  unique,
  state,
  created,
  handleSelect,
  broker,
  role = null,
  selected = false,
}) => {
  const linkRef = useRef(null);

  console.log(broker);

  const pricePerMeter = price / square;

  const handleClick = () => {
    linkRef.current.click();
  };

  const preventPropogate = e => e.stopPropagation();

  const handleCopy = e => {
    e.stopPropagation();
    navigator.clipboard.writeText(`
    1. ID: ${_id};
    2. Tipas: ${CATEGORIES[category].name};
    3. Titulas: ${title};
    4. Kambarių kiekis: ${rooms.length};
    5. Plotas: ${square};
    6. Adresu: ${address};
    7. Kaina: ${price.toLocaleString('lv-LV', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    })};
    8. Kaina už metrą: ${pricePerMeter.toLocaleString('lv-LV', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    })};
    9. Nuoroda: ${HOST_FRONT}${OBJECTS}/${CATEGORIES[category].link}/${_id}.
    `);
    e.target.textContent = 'Nukopijuota';
    setTimeout(() => e?.target && (e.target.textContent = 'Dalintis'), 1000);
  };

  return (
    <StyledObjectsCard onClick={handleClick}>
      {role && (
        <StyledSelectButton onClick={preventPropogate}>
          <RoundRadio
            variants={[' ']}
            square={true}
            fn={handleSelect}
            selected={selected ? 1 : 0}
          />
        </StyledSelectButton>
      )}
      <StyledStateLabelWrapper>
        {state === 1 && (
          <li>
            <span>PARDUODAMA</span>
          </li>
        )}
        {state === 2 && (
          <li className="reserved">
            <span>rezervas</span>
          </li>
        )}
        {state === 3 && (
          <li className="sold">
            <span>PARDUOTA</span>
          </li>
        )}
        {unique && (
          <li className="unique">
            <span>Unikalus</span>
          </li>
        )}
        {Date.now() - Date.parse(created) < 1000 * 60 * 60 * 24 * 30 && (
          <li className="new">
            <span>naujas</span>
          </li>
        )}
      </StyledStateLabelWrapper>
      {!role && (
        <span className="copy" onClick={handleCopy}>
          Dalintis
        </span>
      )}
      <picture>
        {images && images[0] && (
          <>
            <source
              srcSet={`${BASE_URL}/${images[0]}_m.webp`}
              type="image/webp"
            />
            <source
              srcSet={`${BASE_URL}/${images[0]}_m.png`}
              type="image/png"
            />
            <img src={`${BASE_URL}/${images[0]}_m.png`} alt="object" />
          </>
        )}
      </picture>
      <StyledCardInfo>
        {role === 'admin' && broker && (
          <StyledBrokerInfo>
            <picture className="card__photo">
              {!!broker.avatarURL && (
                <>
                  <source
                    srcSet={`${BASE_URL}/${broker.avatarURL}.webp`}
                    type="image/webp"
                  />
                  <source
                    srcSet={`${BASE_URL}/${broker.avatarURL}.png`}
                    type="image/png"
                  />
                </>
              )}
              <img
                src={broker.gravatar}
                alt={broker.name}
                className="image"
                onError={handleImageError(profileimage)}
              />
            </picture>
            <div className="wrap">
              <span className="broker__name">{broker.name}</span>
            </div>
          </StyledBrokerInfo>
        )}
        <StyledCardInfoDetails>
          <StyledCardInfoDetail>
            <span>{CATEGORIES[category].name}</span>
          </StyledCardInfoDetail>
          <StyledCardInfoDetail>
            <span>{`Kambariai: ${rooms.length}`}</span>
          </StyledCardInfoDetail>
          <StyledCardInfoDetail>
            <span>
              {`Plotas: ${square}`}m<sup>2</sup>
            </span>
          </StyledCardInfoDetail>
        </StyledCardInfoDetails>
        <StyledCardTitle>
          <div>
            <h4>{title}</h4>
            <h5>{address}</h5>
          </div>
        </StyledCardTitle>
        <StyledCardPrice>
          <div className="price">
            <span>
              {price.toLocaleString('lv-LV', {
                style: 'currency',
                currency: 'EUR',
                maximumFractionDigits: 0,
              })}
            </span>
            <span className="price--per-m">
              {pricePerMeter.toLocaleString('lv-LV', {
                style: 'currency',
                currency: 'EUR',
                maximumFractionDigits: 0,
              })}{' '}
              m<sup>2</sup>
            </span>
          </div>
          <StyledCardMore
            to={
              role
                ? `${CONSOLE_OBJECTS}/${_id}`
                : `${OBJECTS}/${CATEGORIES[category].link}/${_id}`
            }
            ref={linkRef}
          >
            <ArrowIcon />
          </StyledCardMore>
        </StyledCardPrice>
      </StyledCardInfo>
    </StyledObjectsCard>
  );
};

export const ObjectCardset = ({
  data,
  paddingTop = '65px',
  showMore = true,
  showPages = true,
  role = null,
  handleSelect = () => null,
  selected,
}) => {
  const [perPage, setPerPage] = useState(6);
  const [page, setPage] = useState(1);
  const [dataToShow, setDataToShow] = useState([]);

  const contRef = useRef(null);
  const firstTime = useRef(true);

  const pages = useMemo(
    () => Math.ceil(data.length / perPage),
    [data, perPage],
  );

  const handleSetPerPage = () => {
    if (perPage >= data.length || perPage === 36) return;
    setPerPage(perPage + 6);
  };

  const handleSetPage = index => {
    if (index === '') return;
    if (page > 1 && page < pages && index !== 1)
      setPage(index ? page + 1 : page - 1);
    if (page === 1) setPage(index + 1);
    if (page === pages) {
      if (pages >= 3) setPage(index ? page - 1 : page - 2);
      else setPage(1);
    }
  };

  useEffect(() => {
    if (perPage >= data.length && page > 1) {
      setPage(1);
    } else if (perPage * page > data.length && page !== 1) {
      setPage(pages);
    }
    const objectsToShow = data.filter(
      (_, i) => perPage * page > i && perPage * (page - 1) < i + 1,
    );
    setDataToShow(objectsToShow);
  }, [perPage, page, data, pages]);

  useEffect(() => {
    if (firstTime.current) {
      firstTime.current = false;
    } else
      contRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
  }, [page]);

  return (
    <>
      <StyledObjectsCardset paddingTop={paddingTop} ref={contRef}>
        {dataToShow.map(({ ...props }) => (
          <ObjectCard
            {...props}
            key={props._id}
            handleSelect={handleSelect(props._id)}
            role={role}
            selected={selected ? selected.some(el => el === props._id) : false}
          />
        ))}
      </StyledObjectsCardset>
      {showMore && data.length !== dataToShow.length && (
        <StyledMoreButtonWrapper>
          <MoreButton
            text="Rodyti daugiau"
            fn={handleSetPerPage}
            disabled={data.length === dataToShow.length}
          />
        </StyledMoreButtonWrapper>
      )}
      {showPages && (
        <StyledMoreButtonWrapper>
          {pages > 3 && (
            <Radio
              variants={['<']}
              selected={-1}
              fn={() => setPage(1)}
              disabled={page === 1}
            />
          )}
          <Radio
            variants={['...']}
            selected={-1}
            fn={() => null}
            disabled={true}
            style={{ opacity: page > 2 && page <= pages ? '1' : '0' }}
          />
          <Radio
            variants={Array.from(
              {
                length: pages >= 3 ? 3 : pages,
              },
              (_, i) =>
                page < 3 ? i + 1 : page === pages ? page - 2 + i : page - 1 + i,
            )}
            selected={
              page > 1 && page < pages
                ? 1
                : page === pages && pages > 3
                ? 2
                : page - 1
            }
            fn={handleSetPage}
          />
          <Radio
            variants={['...']}
            selected={-1}
            fn={() => null}
            disabled={true}
            style={{ opacity: page < pages - 1 && pages > 3 ? '1' : '0' }}
          />
          {pages > 3 && (
            <Radio
              variants={['>']}
              selected={-1}
              fn={() => setPage(pages)}
              disabled={page === pages}
            />
          )}
        </StyledMoreButtonWrapper>
      )}
    </>
  );
};

export const TeamCard = ({
  role,
  name,
  avatarURL,
  gravatar,
  phone,
  email,
  about,
}) => {
  return (
    <article className="card">
      <picture className="card__photo">
        {!!avatarURL && (
          <>
            <source
              srcSet={`${BASE_URL}/${avatarURL}.webp`}
              type="image/webp"
            />
            <source srcSet={`${BASE_URL}/${avatarURL}.png`} type="image/png" />
          </>
        )}
        <img
          src={gravatar}
          alt={name}
          onError={handleImageError(profileimage)}
        />
      </picture>
      <div className="card__content">
        <h3 className="card__title">{`${
          role === 'admin' ? 'Direktorė' : 'Brokerė'
        } ${name}`}</h3>
        <address className="card__address">
          {!!phone && <a href={`tel:${phone.split(' ').join('')}`}>{phone}</a>}
          <a href={`mailto:${email}`}>{email}</a>
        </address>
        <div className="card__text">{about}</div>
      </div>
    </article>
  );
};

export const TeamCardsetCards = ({ data }) => {
  return (
    <StyledTeamCardset className="slider">
      {data.map(({ _id, ...props }) => (
        <StyledTeamCard key={_id}>
          <TeamCard {...props} />
        </StyledTeamCard>
      ))}
    </StyledTeamCardset>
  );
};

export const TeamCardset = ({ data }) => {
  const [active, setActive] = useState([0]);
  const cardRef = useRef(null);
  const firstTime = useRef(true);
  const activeLink = useRef(active);

  const { width } = useWindowSize();

  const resetIndicators = useCallback((len, mod = 0) => {
    if (mod === 0) {
      activeLink.current = new Array(len)
        .fill()
        .map((_, i) => activeLink.current[0] + i);
      if (
        activeLink.current[activeLink.current.length - 1] >
        cardRef.current.children[0].children.length - 1
      ) {
        activeLink.current.unshift(activeLink.current[0] - 1);
        activeLink.current.pop();
      }
    } else if (
      !(activeLink.current[0] === 0 && mod === -1) &&
      !(
        activeLink.current[activeLink.current.length - 1] ===
          cardRef.current.children[0].children.length - 1 && mod === 1
      )
    )
      activeLink.current = activeLink.current.map(el => el + mod);
    setActive([...activeLink.current]);
  }, []);

  const handleClick = mod => e => {
    e.stopPropagation();
    let quantity = 1;
    // let rest = data.length - (active[active.length - 1] + 1);
    // let toStart = active[0];
    // if ((mod === 1 && rest === 0) || (mod === -1 && toStart === 0)) return;
    // if (mod === 1 && rest < quantity) quantity = rest;
    // if (mod === -1 && toStart < quantity) quantity = toStart;
    resetIndicators(active.length, mod * quantity);
  };

  const handleSwipe = useCallback(
    e => {
      if (e.target.closest('.slider')) {
        if (e.detail.ended) {
          cardRef.current.children[0].style.transition = e.detail.transition;

          const cardWidth = cardRef.current.children[0].children[0].offsetWidth;
          const movement = Math.abs(e.detail.dirX);

          if (movement > cardWidth / 6) {
            resetIndicators(active.length, -Math.sign(e.detail.dirX));
          } else {
            resetIndicators(active.length, 0);
          }
        } else if (e.detail.started) {
          cardRef.current.children[0].style.transition = 'none';
          cardRef.current.children[0].style.transform = `translateX(${e.detail.moveX}px)`;
        }
      }
    },
    [active.length, resetIndicators],
  );

  useEffect(() => {
    if (cardRef.current) {
      const parentWidth = cardRef.current.offsetWidth;
      const cardWidth = cardRef.current.children[0].children[0].offsetWidth;
      const visibleCount = Math.round(parentWidth / cardWidth);
      if (firstTime.current) {
        document.addEventListener('swipe', handleSwipe);
        firstTime.current = false;
        resetIndicators(visibleCount);
      } else {
        if (visibleCount !== active.length) resetIndicators(visibleCount);
        else
          cardRef.current.children[0].style.transform = `translateX(-${
            active[0] * (cardWidth + 20)
          }px)`;
      }
    }
  }, [handleSwipe, active, width, resetIndicators]);

  useEffect(
    () => () => document.removeEventListener('swipe', handleSwipe),
    [handleSwipe],
  );

  return (
    <StyledTeamCardsetWrapper>
      <StyledTeamSlider ref={cardRef}>
        <TeamCardsetCards data={data} />
        {data.length > 3 && (
          <>
            <StyledTeamControls
              onClick={handleClick(-1)}
              className={active[0] === 0 ? 'left inactive' : 'left'}
            >
              <ArrowSmallIcon className="icon" />
            </StyledTeamControls>
            <StyledTeamControls
              onClick={handleClick(1)}
              className={
                active[active.length - 1] === data.length - 1
                  ? 'right inactive'
                  : 'right'
              }
            >
              <ArrowSmallIcon className="icon" />
            </StyledTeamControls>
          </>
        )}
      </StyledTeamSlider>
      <StyledIndicators>
        {data.map((_, i) => (
          <li
            key={i}
            className={
              active.some(el => i === el) ? 'indicator active' : 'indicator'
            }
          ></li>
        ))}
      </StyledIndicators>
    </StyledTeamCardsetWrapper>
  );
};

export const BrokersCardset = ({ data }) => {
  const history = useHistory();

  const handleClick = id => e => {
    if (e.target.nodeName !== 'A') {
      history.push('brokere/' + id);
    }
  };

  return (
    <StyledBrokersCardset>
      {data.map(({ _id, ...props }) => (
        <StyledTeamCard onClick={handleClick(_id)} key={_id}>
          <TeamCard {...props} />
        </StyledTeamCard>
      ))}
    </StyledBrokersCardset>
  );
};

ObjectCard.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    category: PropTypes.number,
    title: PropTypes.string,
    img: PropTypes.element,
    rooms: PropTypes.array,
    square: PropTypes.number,
    address: PropTypes.string,
    price: PropTypes.string,
    pricePerMeter: PropTypes.string,
  }),
};
